<template>
  <div>
    <v-tabs
      background-color="blue-grey lighten-5"
      grow
      v-model="activeCategory.id"
      :vertical="$vuetify.breakpoint.smAndDown"
      v-if="$vuetify.breakpoint.mdAndUp"
    >
      <v-tab
        v-for="category in categories"
        :key="category.id"
        @click="loadPictures(category)"
      >
        {{ category.displayName }}
      </v-tab>
    </v-tabs>
    <div class="text-center" v-else>
      <v-chip
        class="ma-1"
        v-for="category in categories"
        :key="category.id"
        :color="
          category.id === activeCategory.id ? 'primary' : 'grey lighten-4'
        "
        @click="loadPictures(category)"
      >
        {{ category.displayName }}
        <v-avatar right>
          {{ category.pictureCount }}
        </v-avatar>
      </v-chip>
    </div>
    <Carousel :pictures="pictures" v-if="hasPictures" />
    <!-- <section class="pictures">   -->
    <!-- <Carousel
        class="hidden-md-and-up"
        :pictures="pictures"
        v-if="hasPictures"
      />
      <Grid
        class="hidden-sm-and-down mx-n3"
        :pictures="pictures"
        v-if="hasPictures"
      /> -->
    <!-- </section> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import { cloneDeep, isEmpty } from "lodash";

export default {
  name: "GalleryCategories",
  components: {
    Carousel: () => import("./Carousel"),
    // Grid: () => import("./Grid"),
  },
  data() {
    return {
      pictures: [],
    };
  },
  methods: {
    ...mapMutations("pictures", ["setActiveCategory"]),
    loadPictures(category) {
      this.setActiveCategory(category);

      switch (category.key) {
        case "awards":
          this.pictures = cloneDeep(this.awards);
          break;
        case "habitats":
          this.pictures = cloneDeep(this.habitats);
          break;
        case "turkeys":
          this.pictures = cloneDeep(this.turkeys);
          break;
        case "waterfowl":
          this.pictures = cloneDeep(this.waterfowl);
          break;
        default:
          console.log(`Sorry, no category was passed in.`);
          this.setActiveCategory(this.defaultCategory);
          this.pictures = cloneDeep(this.habitats);
      }
    },
  },
  computed: {
    ...mapGetters("pictures", [
      "categories",
      "defaultCategory",
      "awards",
      "habitats",
      "turkeys",
      "waterfowl",
    ]),
    ...mapState("pictures", ["activeCategory"]),
    hasPictures() {
      return !isEmpty(this.pictures);
    },
  },
  mounted() {
    let category = isEmpty(this.activeCategory)
      ? this.categories.filter((c) => c.key === "awards")[0]
      : this.activeCategory;
    this.loadPictures(category);
  },
  watch: {
    "$store.state.pictures.activeCategory": function() {
      this.loadPictures(this.activeCategory);
    },
  },
};
</script>

<style scoped>
.pictures {
  background-color: white;
}
</style>
